import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Modal } from '@atoms';
import { Control, UseFormHandleSubmit } from 'react-hook-form';
import AddMonitoringModalForm from './AddMonitoringModalForm';
import { MonitoringItem } from '@services';

interface MainModalProps {
  isEdit: boolean;
  open: boolean;
  isValid: boolean;
  isLoading: boolean;
  control: Control<MonitoringItem, any>;
  handleSubmit: UseFormHandleSubmit<MonitoringItem>;
  onClose: () => void;
  onFinalSubmit: (data: MonitoringItem) => void;
  title: string;
  subtitle: string;
}

const MainModal: React.FC<MainModalProps> = ({
  isEdit,
  open,
  isValid,
  isLoading,
  control,
  handleSubmit,
  onClose,
  onFinalSubmit,
  title,
  subtitle,
}) => {
  return (
    <Modal title={title} open={open} onClose={onClose}>
      <Box
        component="form"
        display="flex"
        flexDirection="column"
        onSubmit={handleSubmit(onFinalSubmit)}
      >
        <Typography variant="body2" mt="8px" color="text.secondary" mb="40px">
          {subtitle}
        </Typography>
        <AddMonitoringModalForm control={control} />
        <Box display="flex" justifyContent="flex-end">
          <Button color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton variant="contained" type="submit" disabled={!isValid} loading={isLoading}>
            {isEdit ? 'Update' : 'Create'}
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default MainModal;
